import SvnLogo from "@/components/SvnLogo";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-20 md:py-28" data-testid="about-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold mb-4">Our Story</p>
      <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter">
        Signal Voice <span className="text-svn-red">Network.</span>
      </h1>
      <p className="mt-6 font-display text-2xl md:text-3xl text-gold tracking-tight">
        Different Voices. One Signal.
      </p>

      <div className="mt-12 space-y-6 text-lg text-neutral-300 font-body">
        <p>
          SVN Network is a digital media company built around authentic
          conversations: culture, food, sports, relationships, personal growth,
          travel, business, technology and current events.
        </p>
        <p>
          The network is a home for multiple branded shows under one umbrella —
          a place where different perspectives are shared, the community is
          built, and the conversations actually matter.
        </p>
        <p>
          Our mission is simple: cut through the noise. Bring real voices to
          the front. Build a platform where listeners feel seen, sponsors find
          alignment, and creators have the resources to do their best work.
        </p>
      </div>

      <div className="mt-20 grid md:grid-cols-3 gap-6">
        {[
          { k: "5", v: "Branded shows on the network" },
          { k: "7", v: "Days a week, new content drops" },
          { k: "∞", v: "Conversations still ahead" },
        ].map((s) => (
          <div key={s.v} className="bg-[#0F0F0F] border border-white/5 p-8">
            <p className="font-display text-6xl font-black text-gold">{s.k}</p>
            <p className="mt-3 text-sm text-neutral-400 uppercase tracking-widest font-body">
              {s.v}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-20 bg-[#0F0F0F] border border-white/5 p-10 md:p-16 text-center">
        <SvnLogo size="lg" />
        <p className="mt-6 font-display text-2xl md:text-3xl tracking-tight">
          Where the culture meets the conversation.
        </p>
      </div>
    </div>
  );
}
